/*
 * Purpose : User Management Landing page
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React,{ useState, useEffect } from 'react';
import ReactTable from 'react-table';
import {FaCheckCircle,FaEdit} from "react-icons/fa";
import {MdDeleteForever } from 'react-icons/md';
import {AiFillCloseCircle, AiOutlineUserAdd} from "react-icons/ai";
import { Alert, Modal, ModalBody, ModalHeader, Row, Col } from 'reactstrap'
import axios from 'axios';

import "./UserManagement.css";
import Aux from '../../../hoc/Auxilliary/Auxilliary';
import {userTableHeaders} from '../../../config/constants';
import UserForm from '../../../components/UserManagement/AddEditUserForm'
import LoadingModal from '../../../components/UI/modals/loadingModal';
import BackButton from "../../../components/UI/Buttons/BackButton/BackButton"
import {colors} from "../../../styleConstants"
//amplify
import { API, graphqlOperation } from 'aws-amplify';
import {createExcessuserroles, updateExcessuserroles} from '../../../graphql/mutations';
import ToolSalesButton from '../../../components/UI/Buttons/ToolSalesButton/ToolSalesButton';
import DeleteAlertModal from '../../../components/UI/modals/DeleteAlertModal';



const UserManagement = () => {
    //console.log("UserManagement Component imported")
    const [loading, setLoading] = useState(false)
    const [modal, setModal] = useState(false);
    const [stateValues, setStateValues] = useState({});
    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(null)
    const [deleteModal, setDeleteModal] = useState(false)
    const [row, setRow] = useState({})
    const [data, setData] = useState([])
    const [columns, setColumns] = useState([])

    const toggleModal = () => setModal(!modal);

    // to get all the existing user roles to display
    const getUserRoles = async() => {
        const q = `query 
                {listExcessuserroless(limit:${process.env.REACT_APP_USERROLES_TABLE_LIMIT}){
                    items{
                        id
                        email
                        role
                        submitlist
                        approvelist
                        reportlist
                        sales_notification
                        sales_week_report
                    }
                }}`;
            const apiData =await API.graphql(graphqlOperation(q))
            const results = apiData.data.listExcessuserroless.items;
            const data = results.map(e => {
                const rec = { ...e }
                rec.actions = buildActions(e)
                return rec
            })
            console.log("data fetched")
            return data
    }
   
    // to call on submit the add or edit form.
    const submithandler = async (email,role,submitlist,approvelist,reportlist,sales_notification,sales_week_report, action) => {
        // console.log("email=>",email)
        // console.log("role=>",role)
        // console.log("submitlist=>",submitlist)
        // console.log("approvelist=>",approvelist)
        // console.log("action=>",action)
        const userRecord = {
            id: email.toLowerCase(),
            email: email.toLowerCase(),
            role: role,
            submitlist: submitlist?"Yes":"No",
            approvelist: approvelist?"Yes":"No",
            reportlist: reportlist?"Yes":"No",
            sales_notification: sales_notification?"Yes":"No",
            sales_week_report: sales_week_report?"Yes":"No"
        }
        //console.log("userRecord=>",userRecord)
        await API.graphql(graphqlOperation(action ==='add' ? createExcessuserroles:updateExcessuserroles, {input:userRecord}))
        .then(async result =>
            {
                //console.log("result createUserroles ==>",result)
                setModal(false)
                if(action==="add"){
                    setSuccess("User was added successfully.!")
                }
                else{
                    setSuccess("User was updated successfully.!")
                }
                const data = await getUserRoles()
                //console.log("data 2 =>",data)
                setData(data)
            }
        ).catch(error => {
            console.log("error createUserroles ==>",error.errors && error.errors[0].errorType)
            console.log("err while processing user role submit=>", JSON.stringify(error, null, 4))
            const reqBody = {
                level:"error",
                message: "Error while processing user role submit. error: "+JSON.stringify(error, null, 4)
            }
            axios.post( `${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                            reqBody,
                            { headers: {'x-api-key':process.env.REACT_APP_REST_API_KEY} }
                        );
            
            setModal(false)
            if(error.errors && error.errors[0].errorType.indexOf("ConditionalCheckFailedException") !== -1)
            {
                setError("Duplicate record found.! Please check and try again.!")
            }
            else{
                setError("There is some error.! Please try again.!")
            }
        });
    }
    
    // function to call on click of add user
    const addFormHandler = () =>{
        setStateValues({
            email:"",
            role:"",
            submitlist:"",
            approvelist:"",
            reportlist:"",
            sales_notification:"",
            sales_week_report:"",
            action:"add"
        })
        setModal(true)
    }
    
    // function to call on click of edit user
    const editFormHandler = (editRow) =>{
        //console.log("row->",editRow)
        editRow.action="edit"
        setStateValues(editRow)
        setModal(true)
    }
    // function to call on click of delete user
    const confirmDelete = (row) => {
        setRow(row)
        setDeleteModal(true)
    }
    // function to call to delete a user on confirm delete
    const deleteHandler = async (row) => {
        //console.log("row=>",row);
        setLoading(true)
        setDeleteModal(false)
        const q = `mutation {
                deleteExcessuserroles(input: {id: "${row.id}" }) {
                    email
                    id
                }
            }`
        //console.log("q=>",q)
        const apiData =await API.graphql(graphqlOperation(q))
        //console.log("apiData=>",apiData.data.deleteExcessuserroles)
        setLoading(false)
        if(apiData.data.deleteExcessuserroles && apiData.data.deleteExcessuserroles!=null)
        {
            setSuccess(`User : ${apiData.data.deleteExcessuserroles.email} was removed successfully.!`)
            const data = await getUserRoles()
            //console.log("data 3 =>",data)
            setData(data)
        }
        else{
            console.log("err while deleting user role=>", error)
            const reqBody = {
                level:"error",
                message: "Error while deleting user role. error: "+error
            }
            axios.post( `${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                            reqBody,
                            { headers: {'x-api-key':process.env.REACT_APP_REST_API_KEY} }
                        );
            setError("Error while deleting the record.! Please try again.!")
            
        }
    }

    // function to add action buttons
    const buildActions = (tableRow) => {
        const actions = [];
        //console.log("tableRow=>",tableRow)
        actions.push(
            <div key={tableRow.email} className={"actionDivUser"}>
                {/* <Button className={"editBtn"} color="warning" onClick={() => editFormHandler(tableRow) }>Edit{'  '}</Button>
                <Button className={"delBtn"} color="danger" onClick={() => confirmDelete(tableRow)}>Delete</Button> */}
                <FaEdit style={{ fontSize: "21px", margin:"0 5%", color:colors.warningColor}} onClick={() => editFormHandler(tableRow) }/>
                <MdDeleteForever style={{ fontSize: "21px", margin:"0 5%", color:colors.dangerColor}} onClick={() => confirmDelete(tableRow)}/>
            </div>
        )
        return actions
    }
    
    useEffect( () => {
        setLoading(true)
        // building the columns for react table to show in the table
        const buildData = async () => {
            // set Table Headers
            const columns = []
            Object.keys(userTableHeaders).forEach((col, i) => {
                if (col.toLowerCase() === "actions") {
                    columns.push({
                        Header:userTableHeaders[col],
                        accessor:col,
                        filterable:false,
                        maxWidth: 70,
                        headerClassName: 'header-style',
                        className:'column-style'
                    })
                }
                else if( col === "sales_notification" || col === "sales_week_report" ){
                    columns.push({
                        Header:userTableHeaders[col],
                        accessor:col,
                        filterable:true,
                        //maxWidth: 130,
                        headerClassName: 'header-style',
                        className:'column-style',
                        Cell: e=> {
                            if(e.value==="Yes")
                                return <div style={{textAlign:"center"}}><FaCheckCircle color="green"/></div>
                            else
                                return <div style={{textAlign:"center"}}><AiFillCloseCircle color="red"/></div>
                        }
                    })
                }
                else if(col === "submitlist" || col === "approvelist" || col === "reportlist"){
                    columns.push({
                        Header:userTableHeaders[col],
                        accessor:col,
                        filterable:true,
                        //maxWidth: 160,
                        headerClassName: 'header-style',
                        className:'column-style',
                        Cell: e=> {
                            if(e.value==="Yes")
                                return <div style={{textAlign:"center"}}><FaCheckCircle color="green"/></div>
                            else
                                return <div style={{textAlign:"center"}}><AiFillCloseCircle color="red"/></div>
                        }
                    })
                }
                else{
                    columns.push({
                        Header:userTableHeaders[col],
                        accessor:col,
                        filterable:true,
                        headerClassName: 'header-style',
                        className:'column-style',
                    })
                }
            });
            setColumns(columns);
            // getting the initial data for users
            const data = await getUserRoles()            
            // console.log("columns=>",columns)
            //console.log("data=>",data)
            setData(data)
            setLoading(false)
        }
        buildData()
    }, [] );

    return (
        <Aux>
            <Alert color="danger" isOpen={error!=null?true:false} toggle={()=> setError(null)}>{error}</Alert>                    
            <Alert color="success" isOpen={success!=null?true:false} toggle={()=> setSuccess(null)}>{success}</Alert>                    
            <Modal isOpen={modal} toggle={toggleModal} size="lg" draggable={false} centered={true}>
                <ModalHeader>User Role Creation</ModalHeader>
                <ModalBody>
                    <UserForm submithandler={submithandler} stateVals={stateValues} closeHandler={toggleModal}/>
                </ModalBody>
            </Modal>
            {/* <Modal isOpen={deleteModal} toggle={()=>setDeleteModal(false)}>
                <ModalBody>
                    <IoMdAlert style={{fontSize:"30px",color:"#c82333"}}/>&nbsp;&nbsp;Are you sure you want to delete this record? You will not be able to undo this action.
                </ModalBody>
                <ModalFooter>
                    <Button color="primary"
                            style={{backgroundColor:"#c82333", borderColor:"#fff", boxShadow:"0px 1px 2px 2px #C0C0C0"}} onClick={()=> deleteHandler(row)}>Delete</Button>{' '}
                    <Button color="secondary" onClick={()=>setDeleteModal(false)}>Cancel</Button>    
                </ModalFooter>
            </Modal> */}
            <DeleteAlertModal open={deleteModal} handler={setDeleteModal} deleteHandler={deleteHandler.bind(this,row)}/>
            <LoadingModal open={loading} msg="Loading..." />
            <div className="topBtnDivSetup">
                <Row form style={{ justifyContent: "flex-end" }}>
                    <Col md="auto">
                        <ToolSalesButton onClick={addFormHandler} ><AiOutlineUserAdd style={{fontSize:"20px"}} />&nbsp;&nbsp;Add User Role</ToolSalesButton>
                    </Col>
                    <Col md="auto">
                        <BackButton path="/setup" label="Go Back"/>
                    </Col>
                </Row>
            </div>     
            { data.length !== 0 ? 
                <div style={ {margin: "0% 2%", width: "-webkit-fill-available !important" } }>                           
                    <ReactTable data={data} columns={columns} defaultPageSize={10} />
                </div>
                : <div className={"noDataDiv"}><p>No data Found.!</p></div> }                    
        </Aux>
    )
}
export default UserManagement;